import { ChipProps } from "@mui/material";

export function getChipProps(params: string): ChipProps {
	if (params === 'in progress'){
		return {
			label: "IN LAVORAZIONE",
			sx: {
				"& .MuiChip-label": {
					color: "background.default"
				},
				backgroundColor: "#07568a",
				borderRadius: 1
			},
		}
	}

	if (params === 'chiuso'){
		return {
			label: "CHIUSO",
			sx: {
				"& .MuiChip-label": {
					color: "background.default"
				},
				backgroundColor: "#669cbc",
				borderRadius: 1
			}
		}
	}

	return {
		label: "Errore",
		color: "error",
		sx: {
			"& .MuiChip-label": {
				color: "background.default"
			},
			borderRadius: 1
		}
	}
}
